// extracted by mini-css-extract-plugin
export default {"description":"resolutionHistoryTable_description__XgKUv"};